import { render, staticRenderFns } from "./PostalUpload.vue?vue&type=template&id=34686c81&"
import script from "./PostalUpload.vue?vue&type=script&lang=js&"
export * from "./PostalUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports